module.exports = __webpack_public_path__ + "static/media/earnedInADay_500000.33e20c3e.png";